export const GET_TASK_PRESCRIBERS_LIST = "GET_TASK_PRESCRIBERS_LIST";
export const GET_TASK_PRESCRIBERS_LIST_SUCCESS = "GET_TASK_PRESCRIBERS_LIST_SUCCESS";
export const GET_TASK_PRESCRIBERS_LIST_FAIL = "GET_TASK_PRESCRIBERS_LIST_FAIL";

export const GET_PRESCRIBERS_LIST = "GET_PRESCRIBERS_LIST";
export const GET_PRESCRIBERS_LIST_SUCCESS = "GET_PRESCRIBERS_LIST_SUCCESS";
export const GET_PRESCRIBERS_LIST_FAIL = "GET_PRESCRIBERS_LIST_FAIL";

export const ADD_PRESCRIBER = "ADD_PRESCRIBER";
export const ADD_PRESCRIBER_SUCCESS = "ADD_PRESCRIBER_SUCCESS";
export const ADD_PRESCRIBER_FAIL = "ADD_PRESCRIBER_FAIL";

export const UPDATE_PRESCRIBER = "UPDATE_PRESCRIBER";
export const UPDATE_PRESCRIBER_SUCCESS = "UPDATE_PRESCRIBER_SUCCESS";
export const UPDATE_PRESCRIBER_FAIL = "UPDATE_PRESCRIBER_FAIL";

export const DELETE_PRESCRIBER = "DELETE_PRESCRIBER";
export const DELETE_PRESCRIBER_SUCCESS = "DELETE_PRESCRIBER_SUCCESS";
export const DELETE_PRESCRIBER_FAIL = "DELETE_PRESCRIBER_FAIL";
